// ── Welle D3c: geschützter Sprung ins Klassenbuch ──
// Das Klassenbuch öffnet eine Stunde nur in einer Klasse aus /api/meine-klassen. Ist die Klasse
// dort nicht enthalten (Stunde ohne Klasse, Kolleg:innen-Klasse über klassen_zugang, archiviert),
// würde sonst dieselbe Stunde der gerade aktiven Klasse aufgehen → dann nur das Datum öffnen.
import { oeffneKlassenbuch } from '../../../lib/nav';
import type { KlasseFachEintrag } from '../../../types';
import { useLader } from './lader';

export function useKlassenbuchSprung() {
  const kl = useLader<KlasseFachEintrag[]>('/api/meine-klassen');
  return (datum: string, stunde: number | null | undefined, klasseId: number | null | undefined) => {
    const eigene = klasseId != null && (kl.daten ?? []).some(k => Number(k.klasse_id) === Number(klasseId));
    oeffneKlassenbuch(eigene ? { datum, stunde: stunde ?? null, klasseId } : { datum });
  };
}
